import { OrderStatus } from './orders';

export interface ReportData {
  dateTime: Date;
  symbol: string;
  execType: number;
  ordStatus: OrderStatus;
  ordQty: number;
  cumQty: number;
  leavesQty: number;
  lastPx: number;
  lastQty: number;
  avgPx: number;
  text: string;
}

export class ReportUtils {
  public static isError(report: ReportData): boolean {
    return report.execType === 2 || report.execType === 7 || report.execType === 10;
  }

  public static formatMessage(report: ReportData): string {
    if (report.execType === 0) {
      return "Order has been accepted.";
    }

    return report.text || (`Status: ${OrderStatus[report.ordStatus]}`);
  }
}
